import XHR from './xhr.js';

class XHRAsset {
  static capacities(asset_type) {
    return XHR.getJson(
      XHR.domain + '/api/'+asset_type+'/capacities',
    );
  }
  static create(asset_type, params) {
    return XHR.postJson(
      XHR.domain + '/api/'+asset_type,
      null,
      params,
    );
  }
}

export default XHRAsset;




// WEBPACK FOOTER //
// ./src/xhr/asset.js